import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setEmail("");
      toast.success("Welcome to Royal Lumina", { description: "The Lumina Letter will arrive soon." });
    }, 700);
  };
  return (
    <section className="py-14 lg:py-24">
      <div className="mx-auto max-w-4xl px-6 lg:px-10">
        <div className="relative bg-primary text-cream rounded-[24px] overflow-hidden p-10 md:p-16 text-center shadow-luxe-hover">
          <div className="absolute -top-20 -right-20 h-64 w-64 rounded-full bg-gold/20 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-gold/10 blur-3xl" />
          <div className="relative">
            <p className="eyebrow">The Lumina Letter</p>
            <h2 className="mt-3 font-display text-4xl md:text-5xl">
              Stay <span className="italic text-gold">Inspired</span>
            </h2>
            <p className="mt-4 text-cream/70 max-w-md mx-auto">
              Subscribe for special offers, new fragrance drops and quiet
              rituals delivered straight to your inbox.
            </p>
            <form onSubmit={onSubmit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 h-14 px-5 rounded-[14px] bg-white/10 border border-white/15 text-cream placeholder:text-cream/40 focus:outline-none focus:border-gold transition-colors"
              />
              <button type="submit" disabled={loading} className="btn-gold h-14 justify-center disabled:opacity-70">
                {loading ? "Subscribing…" : "Subscribe"} <ArrowRight className="h-4 w-4" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
